'use strict';

var _taggedTemplateLiteral = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-variant: normal;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _antd = require('antd');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _theme = require('../../styled/theme');

var _theme2 = _interopRequireDefault(_theme);

var _isSp = require('../../utils/isSp');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ModalTitle = _styledComponents2.default.div(_templateObject());

exports.default = function (_ref) {
  var config = _ref.config,
      title = _ref.title,
      footer = _ref.footer,
      children = _ref.children,
      _ref$shouldCloseOnOve = _ref.shouldCloseOnOverlayClick,
      shouldCloseOnOverlayClick = _ref$shouldCloseOnOve === void 0 ? true : _ref$shouldCloseOnOve,
      width = _ref.width;
  var isSpCheck = (0, _isSp.isSp)();
  var modalStyles = {
    content: {
      backgroundColor: isSpCheck ? _theme2.default.navy : 'rgb(18, 32, 39)',
      color: isSpCheck ? _theme2.default.spText : _theme2.default.gray300,
      width: width ? width : '540px'
    }
  };
  var headerStyles = {
    background: isSpCheck ? 'transparent' : '#122027',
    color: isSpCheck ? _theme2.default.spText : '#D3D4D9'
  };
  var closeStyle = {
    color: isSpCheck ? _theme2.default.spText : '#5588A1'
  };
  return _react2.default.createElement(_reactModal2.default, _extends({}, config, {
    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
    className: "react-modal-container ".concat(config && config.className ? config.className : ''),
    style: modalStyles,
    overlayClassName: "react-modal-overlay ".concat(config && config.overlayClassName ? config.overlayClassName : ''),
    appElement: config && config.appElement ? config.appElement : document.body
  }), config && !config.withoutHeader && _react2.default.createElement('div', {
    className: 'react-modal-header',
    style: headerStyles
  }, _react2.default.createElement(ModalTitle, {
    className: 'react-modal-title'
  }, title || ''), _react2.default.createElement('button', {
    onClick: config && config.onRequestClose,
    className: 'react-modal-close',
    style: closeStyle
  }, _react2.default.createElement(_antd.Icon, {
    type: 'close',
    style: closeStyle,
    'data-html2canvas-ignore': true
  }))), config && !config.withoutBody && _react2.default.createElement('div', {
    className: 'react-modal-body',
    style: headerStyles
  }, children || ''), config && !config.withoutFooter && _react2.default.createElement('div', {
    className: 'react-modal-footer'
  }, footer || ''));
};
/*
Example of usage:

  const modalFooter = (
   <Button onClick={() => {}} type="primary">Ok</Button>
   <Button onClick={() => {}}>Close</Button>
  );

  <Modal
    config={
     ...sameParamsAsForReactModal (look documentation)

     (if you don't want to show header, footer or body, you should write it in config)

     withoutHeader={true}
     withoutBody={true}
     withoutFooter={true}
    }
    title="Modal title!"
    footer={modalFooter}
  >
    <p>Some text in modal body</p>
  </Modal>
* */